export const userLink = ($http: HttpApi) => ({
  get: (viewId: string, { fieldId, recordId }: { fieldId: string, recordId: string }) => $http.$get(`/views/${viewId}/fields/${fieldId}/links/user_link`, {
    params: { record_id: recordId },
  }),
});
